export type AccessRequirement = {
    /** A truthy condition that must be met to allow the user to remain on this page. */
    requirement: boolean;
    /** By default, unauthorized users will be shown an error screen. This overrides the destination they're redirected to. */
    redirectUri?: string;
};

/**
 * Redirects the user to a 'no access' error page if the provided truthy value is false.
 */
export function useRestrictAccess({ requirement, redirectUri }: AccessRequirement) {
    if (!requirement) {
        window.location.replace(redirectUri ?? '/error/noaccess');
    }
}
